export default [
  {
    path: '/satis-firma',
    name: 'satis-firma-list',
    component: () => import('./index.vue'),
    meta: {
      public: false,
      title: 'satis_firma.Baslik',
      yetki: { k: [2001902] },
    },
  },
]
